export default "__VITE_ASSET__804caaa0__"